<template>
  <div class="menu">
    <div v-for="(item1, index1) in list" :key="index1">
      <u-card :title="item1.mainTitle" :border="false"
        title-color="#FFFFFF" box-shadow="0px 2px 2px 2px #eee;" :foot-border-top="false"
        class="u-m5-y-2"
        >
        <div class="" slot="body">
          <div class="u-body-item u-myflex u-j-sb u-p5-t-0">
            <div class="main">
              <div class="u-w-20" v-for="(item2, index2) in item1.mainList" :key="index2" @click="toggleA(item2)">
                <div class="img u-text-center">
                  <div class="iconfont" :class="item2.img" style="font-size: 70px"
                    :style="{ color: item1.mainColor }"></div>
                </div>
                <div class="route_title u-text-center u-color-light">
                  {{ item2.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </u-card>
    </div>
  </div>
</template>

<script>
import UCard from "@/components/u-card.vue"
import { mapMutations, mapState } from "vuex";
export default{
  name:"Index",
  components:{UCard},
  data(){
    return{
      userAuthorities:null,
      list:[]
    }
  },
  computed: {
    ...mapState({
      ativeNavbar: (state) => state.topnav_activeNav1,
    }),
  },
  methods:{
    ...mapMutations(["topnav_activeNav1", "documentTitle_menuName"]),
    //路由跳转
    jumpRouter(menuId, menuName) {
      this.$router.push({
        name: menuId,
      });
      // sessionStorage.setItem()
    },
    toggleA(item) {
      console.log(item);
      const documentTitle_menuName = {};
      documentTitle_menuName[item.id] = item.name;
      this.documentTitle_menuName(documentTitle_menuName);
      this.jumpRouter(item.id, item.name);
    },
      // pageChage(obj) {
      //   //console.log('obj',obj);
      //   let urlstr = obj.url
      //   if (obj.title.indexOf('审批') > -1) {
      //     uni.navigateTo({
      //       url: urlstr + '?' + obj.type + "=1"
      //     });
      //   } else {
      //     uni.navigateTo({
      //       url: urlstr + '?type=' + encodeURIComponent(JSON.stringify(obj))
      //     });
      //   }
      // },
    newGetMenus(){
      const data = this.$store.state.sbNav
          const type={
            colorArr:["",'#32b2f1','#aaC1ff','#52f1f1', '#f0a111','#55aaff', '#00F200'],
            carArr:["",'icon-jiaoche','icon-keche','icon-huoche', 'icon-weixianpinche','icon-renyuan', 'icon-qiye'],
            declareType:["","qy","ls","tq"],
            vehicleType:["","jc","kc","hc","wxp","ry"],
          }
          if (data&&data.length) {
            this.list=[]
            data.forEach((item) => {
              if(item.name==="测试菜单")return;
              const mainList = []
              if(item.children)item.children.forEach((item2) => {
                if(item.name==='申报审批')
                  mainList.push({ // 审批 type和icon 都是单独处理
                    img:item2.vehicleType==5?"icon-renyuanshenpi":"icon-cheliangshenpi",
                    title: item2.name,
                    name:item2.name,
                    id:item2.id,
                    type:item2.vehicleType==5?"personType":"vehicleType",
                    declareType: item2.declareType,
                    vehicleType: item2.vehicleType
                  })
                else
                  mainList.push({
                    img:type.carArr[parseInt(item2.vehicleType)],
                    title: item2.name,
                    name:item2.name,
                    id:item2.id,
                    type:type.declareType[parseInt(item2.declareType)]+type.vehicleType[parseInt(item2.vehicleType)],
                    declareType: item2.declareType,
                    vehicleType: item2.vehicleType
                  })
              })
              this.list.push({
                declareType: item.name==='申报审批'?100:item.declareType,
                mainTitle: item.name,
                mainColor: type.colorArr[item.declareType||type.colorArr.length-1],
                mainList
              })
            })
          }
          this.list.sort((a,b)=>a.declareType - b.declareType)
    },
  },
  created(){
    //this.userAuthorities = this.$store.getters.get_userAuthorities
    this.newGetMenus()
  }
}
</script>

<style lang="scss" scoped>
.menu{
  width: 80%;
  margin: 0 auto;
  padding-bottom: 100px;
  transform-origin: 50% 0;
  transform: scale(0.8);
  .main{
    width: 100%;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/sbgl/menu.vue